import React, { useState } from "react";
import axios from "axios";
import AlvnaBrand from "../components/AlvnaBrand";
import { ContactSupportModal, SetupModal } from "../components/SupportModals";
import { endpoints } from "../apiConfig";
import { colors, fonts, space, radius, buttonPrimary, buttonSecondary, inputBase } from "../theme";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showForgot, setShowForgot] = useState(false);
  const [showContact, setShowContact] = useState(false);
  const [showSetup, setShowSetup] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const res = await axios.post(endpoints.login, { email, password });
      localStorage.setItem("token", res.data.access_token);
      localStorage.setItem("tenant", JSON.stringify(res.data.tenant));
      window.location.href = "/dashboard";
    } catch (err) {
      setError(err.response?.data?.error || "Login failed.");
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <AlvnaBrand variant="full" />
        <form onSubmit={handleLogin} style={styles.form}>
          <h2 style={styles.heading}>Login</h2>
          {error && <div style={styles.error}>{error}</div>}
          <input
            style={styles.input}
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            style={styles.input}
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button style={styles.button} type="submit">Log In</button>

          <div style={styles.linksRow}>
            <button type="button" style={styles.linkBtn} onClick={() => setShowForgot(true)}>
              Forgot password?
            </button>
          </div>

          <div style={styles.actionsRow}>
            <button type="button" style={styles.secondaryBtn} onClick={() => setShowContact(true)}>
              Contact Support
            </button>
            <button type="button" style={styles.secondaryBtn} onClick={() => setShowSetup(true)}>
              Setup Guide
            </button>
          </div>
        </form>
      </div>

      {showForgot && <ForgotPasswordModal onClose={() => setShowForgot(false)} />}
      {showContact && <ContactSupportModal onClose={() => setShowContact(false)} prefillEmail={email} />}
      {showSetup && <SetupModal onClose={() => setShowSetup(false)} />}
    </div>
  );
}

function ForgotPasswordModal({ onClose }) {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    await axios.post(endpoints.forgotPassword, { email });
    setSent(true);
  };

  return (
    <Modal onClose={onClose} title="Forgot Password">
      {sent ? (
        <p style={styles.modalText}>If that email is registered, a reset link has been sent. Check your inbox.</p>
      ) : (
        <form onSubmit={submit} style={styles.form}>
          <input
            style={styles.input}
            type="email"
            placeholder="Your account email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button style={styles.button} type="submit">Send Reset Link</button>
        </form>
      )}
    </Modal>
  );
}

function Modal({ title, children, onClose }) {
  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div style={styles.modalHeader}>
          <strong style={{ fontFamily: fonts.display }}>{title}</strong>
          <button style={styles.closeBtn} onClick={onClose}>×</button>
        </div>
        <div style={{ padding: space[4] }}>{children}</div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: colors.bgPage,
    padding: space[4],
    boxSizing: "border-box",
  },
  card: {
    width: "100%",
    maxWidth: 380,
    background: colors.surface,
    borderRadius: radius.lg,
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    overflow: "hidden",
  },
  form: { display: "flex", flexDirection: "column", gap: space[3], padding: space[5] },
  heading: { margin: "0 0 4px", fontFamily: fonts.display, fontSize: 19, fontWeight: 600, textAlign: "center", color: colors.textPrimary },
  input: inputBase,
  button: buttonPrimary,
  secondaryBtn: { ...buttonSecondary, flex: 1, textAlign: "center" },
  linksRow: { textAlign: "center" },
  linkBtn: { background: "none", border: "none", color: colors.brandBlue, cursor: "pointer", fontSize: 13, fontFamily: fonts.body },
  actionsRow: { display: "flex", gap: space[2], marginTop: 4 },
  error: { color: "#b91c1c", fontSize: 13, textAlign: "center", fontFamily: fonts.body },
  overlay: {
    position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)",
    display: "flex", alignItems: "center", justifyContent: "center",
  },
  modal: { width: 360, maxWidth: "calc(100vw - 24px)", background: colors.surface, borderRadius: radius.md, overflow: "hidden" },
  modalHeader: {
    display: "flex", justifyContent: "space-between", alignItems: "center",
    padding: `${space[3]} ${space[4]}`, borderBottom: `1px solid ${colors.border}`,
  },
  closeBtn: { background: "none", border: "none", fontSize: 20, cursor: "pointer" },
  modalText: { fontFamily: fonts.body, color: colors.textPrimary, padding: space[4] },
};
